import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CommonService } from '../../shared/common.service';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  loginForm: FormGroup;
  formSubmitted: boolean = false;
  errorMsg: string = "Ok";
  headers = [];
  adminUser: boolean = true;
  clubUser: boolean = false;
  LoginFlag: boolean = true;
  ResetFlag: boolean = false;
  Loginmessage: string = "";
  isLoading: boolean = false;
  emailPattern = /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;
  
  constructor(private fb: FormBuilder,
    private authServices: AuthService,
    private commonService: CommonService,
    private router: Router) { }

  ngOnInit() {
    this.initialiseForms();
  }
  initialiseForms() {
    this.loginForm = this.fb.group({
      userName: ["", [Validators.required,Validators.pattern(this.emailPattern)]],
      password: ["", [Validators.required]]
    });
  }
  
  loginFN() {
    this.router.navigate(['main/dashboard'])
  }

  login() {
    this.formSubmitted = true;
    if (this.loginForm.valid) { 
      let req = {
        email: this.loginForm.controls["userName"].value,
        password: this.loginForm.controls["password"].value
      };
      this.isLoading = true;
      this.authServices.validateLogin(req).subscribe((res: HttpResponse<any>) => {
        this.isLoading = false;
        if ((res["message"] = "Success")) {
          this.commonService.setStorage("token", res.headers.get('Authorization'));
          let userData = this.commonService.getUser();
          this.router.navigate(["main/dashboard"]);
        } else {
        }
      },
        err => {
          this.isLoading = false;
        });
    }
  }

} 
